'use client';

import { useEffect } from 'react';

export default function HomePage() {
  useEffect(() => {
    try {
      const raw = localStorage.getItem('buildops-auth');
      if (raw) {
        const data = JSON.parse(raw);
        if (data.state?.isAuthenticated) {
          window.location.href = '/dashboard';
          return;
        }
      }
    } catch (err) {
      console.warn('[Auth] повреждённый auth-state в localStorage → на логин:', (err as Error).message);
    }
    window.location.href = '/login';
  }, []);

  return (
    <div className="h-[100dvh] flex items-center justify-center gradient-mesh">
      <div className="animate-pulse-soft text-neutral-400 text-sm">Загрузка...</div>
    </div>
  );
}
